import React from 'react';
import TSG from '../../components/TSG';

const TenantTSG = () => {
  return <TSG mode="tenant" />;
};

export default TenantTSG;
